/** @jsxImportSource @emotion/react */
import React, { useState } from 'react';

import { IProduct, IProductVariant } from '@ddot/AddToCartCommon/lib/entities';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

import Utils from 'Lib/Utils';

import {
    productDetailsText,
    productDropdown,
    productVariationText,
    variantContainer,
    variantDetailsContainer,
    variationOption,
} from '../Styles/ProductDetailsStyles';

interface PropType {
    product: IProduct;
    selectedVariant?: IProductVariant;
    onVariantSelected(variant: IProductVariant): void;
    title?: boolean;
    type: string;
}

interface ParsedProductVariant extends IProductVariant {
    displayString: string;
}

const VariantSelector = (props: PropType): JSX.Element | null => {
    const { product, selectedVariant, onVariantSelected, title, type } = props;

    const [isOpen, setIsOpen] = useState(false);

    const toggle = () => setIsOpen(!isOpen);

    const variants = Utils.Product.getVariants(product);
    if (!variants.length) return null;

    const parsedVariants: ParsedProductVariant[] = variants.map((item: IProductVariant) => {
        const displayString = Utils.Product.getItemVariantSizeLengthString(item);

        return {
            ...item,
            displayString,
        };
    });

    const sortedVariants = parsedVariants.sort((a: ParsedProductVariant, b: ParsedProductVariant) => {
        const stringA = a.displayString.toUpperCase();
        const stringB = b.displayString.toUpperCase();

        if (stringA < stringB) return 1;
        if (stringA > stringB) return -1;
        return 0;
    });

    const renderSelectedVariant = (): string => {
        if (!selectedVariant) return 'Choose an option';
        return Utils.Product.getItemVariantSizeLengthString(selectedVariant);
    };

    const isSelectedVariant = (variant: IProductVariant) => {
        if (selectedVariant?.sku === variant.sku) {
            return true;
        }
        return false;
    };

    return (
        <>
            {
                type === 'details'
                    ? (
                        <div style={{ display: 'flex', gap: '20px' }}>
                            {title && <div css={productDetailsText}>Size / Weight</div>}
                            <div css={variantDetailsContainer} style={{ border: `${sortedVariants.length > 10 ? '1px solid #E6DFD8' : 'none'}`, height: `${sortedVariants.length > 10 ? '16rem' : 'auto'}` }}>
                                {sortedVariants.map((variant) => {
                                    return (
                                        <div
                                            className={`${isSelectedVariant(variant) ? 'selected' : ''}`}
                                            role='button'
                                            tabIndex={0}
                                            onClick={() => onVariantSelected(variant)}
                                            onKeyPress={() => onVariantSelected(variant)}
                                            css={variationOption}
                                        >
                                            <p key={variant.displayString}>{variant.displayString}</p>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    )
                    : (
                        <div css={variantContainer}>
                            {title && <div css={productDetailsText}>Size/Weight</div>}

                            <Dropdown isOpen={isOpen} toggle={toggle}>
                                <DropdownToggle css={productDropdown} caret>
                                    {renderSelectedVariant()}
                                </DropdownToggle>
                                <DropdownMenu style={{ maxHeight: '210px', overflowY: 'scroll' }}>
                                    {sortedVariants.map((variant) => {
                                        return (
                                            <DropdownItem
                                                css={productVariationText}
                                                key={variant.displayString}
                                                onClick={() => onVariantSelected(variant)}
                                            >
                                                {variant.displayString}
                                            </DropdownItem>
                                        );
                                    })}
                                </DropdownMenu>
                            </Dropdown>
                        </div>
                    )
            }
        </>
    );
};

VariantSelector.defaultProps = {
    selectedVariant: undefined,
    title: false,
};

export default VariantSelector;
